module.exports = __webpack_public_path__ + "img/sk-partners-zoznam.7a48c821.svg";